import {
  API_HEADER_KEY,
  API_HEADER_VALUE,
  APP_CHAT_MANAGER_API_URL
} from "../../config";

const API_BASE_URL = APP_CHAT_MANAGER_API_URL;

class ApiRoutes {
  private static readonly BASE_URL = API_BASE_URL;

  static streamingChat(): string {
    return `${this.BASE_URL}/agenda-cultural-ara-api/v1/chat/stream`;
  }

  static streamingChatWithAudio(): string {
    return `${this.BASE_URL}/agenda-cultural-ara-api/v1/audio/stream`;
  }

  /**
   * Get list of conversation threads for a user
   * @param _userId - Optional user ID (if not provided, backend should use current session)
   */
  static getThreads(_userId?: string): string {
    // Backend endpoint: GET /api/v1/threads
    // Returns: { user_id: int, threads: list[str] }
    return `${this.BASE_URL}/agenda-cultural-ara-api/v1/threads`;
  }

  /**
   * Get conversation history by thread_id
   * @param threadId - Thread ID
   * @param _userId - Optional user ID (if not provided, backend should use current session)
   */
  static getConversationHistory(threadId: string, _userId?: string): string {
    // Backend endpoint: GET /api/v1/threads/{thread_id}
    // Returns: { thread_id: str, messages: [{ role: str, content: str, timestamp: str }] }
    return `${this.BASE_URL}/agenda-cultural-ara-api/v1/threads/${threadId}`;
  }

  static apiHeaderKey(): Record<string, string> {
    return { [API_HEADER_KEY]: API_HEADER_VALUE };
  }
}

export default ApiRoutes;
